import { BehaviorSubject } from 'rxjs';
import { SubmitActionModel } from 'shared/models/api/models';


export type FatigueAssessmentActionState = {
    action: SubmitActionModel,
    originalAction: SubmitActionModel,
    actionValidation: {},
    checkValidation: boolean
}

const emptyAction: SubmitActionModel = {
    affectedSupervisors: [] as number[],
    confidential: false
};

const createInitialState = (): FatigueAssessmentActionState => ({
    action: Object.assign({}, emptyAction),
    originalAction: emptyAction,
    actionValidation: {},
    checkValidation: false
});

const fatigueAssessmentActionStateSubject = new BehaviorSubject<FatigueAssessmentActionState>(createInitialState());

export const updateActionState = (action: SubmitActionModel) => {
    fatigueAssessmentActionState.setState(s => {
        s.action = action;
    });
}

const updateValidationState = (validation: {}) => {
    fatigueAssessmentActionState.setState(s => {
        s.actionValidation = validation;
    });
}

const isValueInvalid = (value: any) => {
    if (value === undefined) return true;
    if (typeof (value) === 'string' && !value.trim()) return true;
    return false;
}

const validate = (field: string, value: any) => {
    updateValidationState({ ...fatigueAssessmentActionStateSubject.value.actionValidation, [field]: isValueInvalid(value) });
}

export const handleActionChange = (field: string) => (event: any) => {
    let value = (event.target?.value !== undefined) ? event.target?.value : event;
    updateActionState({ ...fatigueAssessmentActionStateSubject.value.action, [field]: value });
    validate(field, value);
};

export const enableActionValidation = () => {
    fatigueAssessmentActionState.setState(s => { s.checkValidation = true });
};

export const resetActionValidation = () => {
    fatigueAssessmentActionState.setState(s => { s.actionValidation = {}, s.checkValidation = false });
};

export const actionFieldInvalid = (field: string) => {
    if (!fatigueAssessmentActionStateSubject.value.checkValidation) {
        return false;
    }
    let value = Object(fatigueAssessmentActionStateSubject.value.actionValidation)[field] as boolean;
    if (value === undefined) return true;
    return value;
}

const requiredFields = [
    ["controlsImplementedById"],
    ["noFurtherAction", "actionTaken", "sentHome"],
    ["comment"],
    ["supervisorSignature"]
];

export const actionStateInvalid = (conditionalFields: string[][] = []) => {
    let invalidGroups = 0;

    const groups = [...requiredFields, ...conditionalFields];

    //ensure at least 1 field per group has a value
    groups.forEach(group => {
        let valid = false;
        group.forEach(field => {
            if (!actionFieldInvalid(field)) valid = true;
        });
        if (!valid) invalidGroups++;
    });

    return invalidGroups;
}

export const fatigueAssessmentActionState = {
    subscribe: (setState: any) => fatigueAssessmentActionStateSubject.subscribe(setState),
    setState: (fn: (state: FatigueAssessmentActionState) => void) => {
        var newState = Object.assign({}, fatigueAssessmentActionStateSubject.getValue());
        fn(newState);
        fatigueAssessmentActionStateSubject.next(newState);
    },
    reset: () => {
        fatigueAssessmentActionStateSubject.next(createInitialState());
    }
}
